import { ResolverTag } from '@ps/web-core-enums';
import { Size } from '@ps/web-core-store';
import {
  CrossPlatformLink,
  StarsButton,
  Translation,
  useResolver
} from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import type { Dispatch } from '@swf/core/store';
import { BaseHeader, theme } from '@swf/poker';

import {
  TXTCLI_A_copy_Xfront_and_backX_of_a_v_ELL,
  TXTCLI_A_recent_proof_of_address_docu_ELL,
  TXTCLI_More_information_on_Xa_hrefXXN_ELL,
  TXTCLI_OK,
  TXTCLI_To_finalize_your_registration__ELL_1,
  TXTCLI_Validation_Required,
  TXTCLI_Verify_My_Account,
  TXTCLI_You_can_gain_access_to_our_ful_ELL
} from './VerifyAccount.messages.json';
import styles from './VerifyAccount.scss';

const VerifyAccount: React.FC = () => {
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { modal } = useDispatch<Dispatch>();
  const frAuthProcessExplain = useResolver(ResolverTag.FrenchAccountValidation);

  useEffect(() => {
    setStyle({
      closeOnOverlayClick: true,
      closeOnEsc: true,
      overlayClassName: classNames(theme.darkMode, styles.modalOverlay),
      className: classNames(styles.modalContainer, styles.modalContainerCentered),
      size: Size.MEDIUM
    });
  }, [setStyle]);

  return (
    <>
      <BaseHeader
        headerClassName={styles.header}
        closeClassName={styles.close}
        title={<Translation {...TXTCLI_Validation_Required} />}
      />
      <Body className={styles.body}>
        <Translation tagName="div" {...TXTCLI_You_can_gain_access_to_our_ful_ELL} />
        <Translation tagName="div" {...TXTCLI_To_finalize_your_registration__ELL_1} />
        <ul>
          <Translation tagName="li" {...TXTCLI_A_copy_Xfront_and_backX_of_a_v_ELL} />
          <Translation tagName="li" {...TXTCLI_A_recent_proof_of_address_docu_ELL} />
        </ul>
        <Translation
          tagName="p"
          values={{
            a: (msg: React.ReactNode) => (
              <CrossPlatformLink
                className={styles.link}
                href={frAuthProcessExplain}
                openLinkInNewTab
              >
                {msg}
              </CrossPlatformLink>
            )
          }}
          {...TXTCLI_More_information_on_Xa_hrefXXN_ELL}
        />
        <ButtonGroup className={styles.buttonGroup} inline>
          <CrossPlatformLink className={styles.verifyButton} href="/account/details/verify-account">
            <Translation {...TXTCLI_Verify_My_Account} />
          </CrossPlatformLink>

          <StarsButton
            variant="primary"
            className={styles.cancelButton}
            size="small"
            onClick={() => modal.close()}
            translation={TXTCLI_OK}
          />
        </ButtonGroup>
      </Body>
    </>
  );
};

export default VerifyAccount;
